import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from '@/pages/home/components/Hero';
import FaqSection from '@/pages/home/components/FaqSection';
import CardsSection from '@/pages/home/components/CardsSection';
import { AppSection, ContactSection } from '@/pages/home/components/AppContactSection';
import MediaSection from '@/pages/home/components/MediaSection';
import IndexSection from '@/pages/home/components/IndexSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import AboutSection from '@/pages/home/components/AboutSection';
import RankingSection from '@/pages/home/components/RankingSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <CardsSection />
        <AppSection />
        <ContactSection />
        <MediaSection />
        <IndexSection />
        <CommentsSection />
        <FeaturesSection />
        <UpdatesSection />
        <TopicsSection />
        <CarouselSection />
        <AboutSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}